import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';

const arrayToString = (arr) => {
  if (!arr || arr.length === 0) return '';
  if (arr.length === 1) return arr[0];
  return arr.slice(0, -1).join(', ') + ', ' + arr[arr.length - 1];
};

const stringToArray = (str) => {
  if (!str) return [];
  return str.split(',').map(s => s.trim());
}

export const MultiSelectQuestion = ({ question, answer, onAnswerChange }) => {
  const options = question.q_options;
  const [isNA, setIsNA] = useState(answer === 'N/A');

  useEffect(() => {
    setIsNA(answer === 'N/A');
  }, [question.id]);

  if (!options || !Array.isArray(options)) return null;

  const selected = Array.isArray(answer) ? answer : stringToArray(answer);

  const handleChange = (option) => {
    const updated = selected.includes(option)
      ? selected.filter((v) => v !== option)
      : [...selected, option];
    onAnswerChange(arrayToString(updated));
  };

  const handleNAChange = (e) => {
    const checked = e.target.checked;
    setIsNA(checked);
    onAnswerChange(checked ? 'N/A' : arrayToString([]));
  };

  return (
    <Box sx={{ width: '100%' }}>
      <FormGroup sx={{ width: '100%', gap: 1, pointerEvents: isNA ? 'none' : 'auto', opacity: isNA ? 0.4 : 1 }}>
        {options.map((option, index) => (
          <FormControlLabel
            key={`${option}-${index}`}
            control={
              <Checkbox
                checked={selected.includes(option)}
                onChange={() => handleChange(option)}
                sx={{
                  color: '#ddd',
                  '&.Mui-checked': { color: '#2aa1d3' },
                }}
              />
            }
            label={option}
            sx={{
              border: '1px solid #ddd',
              borderRadius: 2,
              margin: 0,
              padding: '12px 16px',
              '&:hover': { borderColor: '#2aa1d3' },
            }}
          />
        ))}
      </FormGroup>
      {!question.required && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isNA}
              onChange={handleNAChange}
              sx={{
                color: '#ddd',
                '&.Mui-checked': { color: '#2aa1d3' },
              }}
            />
          }
          label="N/A"
          sx={{ mt: 1 }}
        />
      )}
    </Box>
  );
};